import { validate } from 'class-validator';
import { from } from 'rxjs';
export const CLASS_VALIDATOR_GLOBAL_CONFIG = {
  always: true,
  strictGroups: true,
  // enabling skipMissingProperties would allow ANY undefined or null value to pass validation. Essentially it's a global @IsOptional flag. Must be disabled in our setup.
  skipMissingProperties: false,
  // starting with class-validator 0.14.0, forbidUnknownValues defaults to true which caused issues with
  // virtual-property model validation inside of dynamic-form-groups.
  // forbidUnknownValues defaults to true as it is said to fix a security issue,
  // however discussions show this is not the case and disabling it is okay.
  // https://github.com/typestack/class-validator/issues/1422#issuecomment-1317953863
  // as far as I understand the mechanism explained at https://github.com/typestack/class-validator/pull/1798,
  // forbidUnknownValues will add an error "unknownValue: 'an unknown value was passed to the validate function'"
  // in case there is *any* property that has no validationMetadata assigned.
  forbidUnknownValues: false
};
export const CLASS_VALIDATOR_GLOBAL_CONFIG_FORMBUILDER = {
  ...CLASS_VALIDATOR_GLOBAL_CONFIG,
  // default configuration from DFB
  validationError: {
    target: false
  }
};
export function validateModel(model) {
  return from(validate(model, {
    ...CLASS_VALIDATOR_GLOBAL_CONFIG
  }));
}